module.exports = __webpack_public_path__ + "img/chilo-suppressalis.7c85ac0f.jpg";